import {
  computed,
  ref,
  toRef,
} from "vue";

import AHttpAPI from "aloha-vue/src/compositionAPI/AHttpAPI";

import {
  cloneDeep,
  forEach,
} from "lodash-es";

const configForAllTable = ref(undefined);
export const configForAllTableComputed = computed(() => {
  if (configForAllTable.value) {
    return configForAllTable.value;
  }
  try {
    return JSON.parse(localStorage.getItem("table_public_config"));
  } catch (e) {

  }
  return undefined;
});
const ONE_HOUR = 3600 * 1000;

export default function ConfigColumnsFiltersOptionsAPI(props) {
  const hasConfigFromApi = toRef(props, "hasConfigFromApi");
  const id = toRef(props, "id");
  const isSimpleTable = toRef(props, "isSimpleTable");

  const optionsURL = "publictableconfigs/";

  const {
    getListHttp,
  } = AHttpAPI();

  const configForCurrentTable = computed(() => {
    if (!hasConfigFromApi.value || isSimpleTable.value) {
      return undefined;
    }
    return configForAllTableComputed.value?.[id.value];
  });

  const setConfigForAllTable = response => {
    const VALID_UNTIL = new Date(Date.now() + ONE_HOUR);
    const CONFIG_ALL = {};
    forEach(response, item => {
      item._validUntil = VALID_UNTIL;
      CONFIG_ALL[item.tcg_name] = item;
    });
    CONFIG_ALL._validUntil = VALID_UNTIL;
    configForAllTable.value = CONFIG_ALL;
    localStorage.setItem("table_public_config", JSON.stringify(configForAllTable.value));
  };

  const loadConfigForAllTable = () => {
    if (window._tableConfigPromise && !window._tableConfigPromiseIsFulfilled) {
      return window._tableConfigPromise;
    }
    window._tableConfigPromise = new Promise((resolve, reject) => {
      window._tableConfigPromiseIsFulfilled = false;
      if (configForAllTableComputed.value &&
        configForAllTableComputed.value._validUntil &&
        new Date(configForAllTableComputed.value._validUntil) > new Date()) {
        if (!configForAllTable.value) {
          configForAllTable.value = cloneDeep(configForAllTableComputed.value);
        }
        window._tableConfigPromiseIsFulfilled = true;
        return resolve(configForAllTableComputed.value);
      }
      return getListHttp({
        url: optionsURL,
      }).then(
        response => {
          setConfigForAllTable(response);
          return resolve(configForAllTableComputed.value);
        },
        error => {
          return reject(error);
        }
      ).finally(() => {
        window._tableConfigPromiseIsFulfilled = true;
      });
    });
    return window._tableConfigPromise;
  };

  const setConfigForCurrentTable = ({ response, id }) => {
    const CURRENT_CONFIG = response;
    CURRENT_CONFIG._validUntil = new Date(Date.now() + ONE_HOUR);
    configForAllTable.value = configForAllTable.value || {};
    configForAllTable.value[id] = CURRENT_CONFIG;
    localStorage.setItem("table_public_config", JSON.stringify(configForAllTable.value));
  };

  const loadConfigForTable = () => {
    if (!hasConfigFromApi.value || isSimpleTable.value) {
      return;
    }
    return loadConfigForAllTable().then(
      () => {
        return new Promise((resolve, reject) => {
          if (configForCurrentTable.value?._validUntil &&
            new Date(configForCurrentTable.value._validUntil) > new Date()) {
            return resolve();
          }
          return getListHttp({
            url: optionsURL,
            urlParams: {
              bez: id.value
            },
            headerParams: {
              detail: true,
            },
          }).then(
            response => {
              if (response.length) {
                setConfigForCurrentTable({
                  response: response[0],
                  id: id.value,
                });
              }
              return resolve();
            },
            error => {
              return reject(error);
            }
          );
        });
      }
    );
  };

  return {
    configForAllTableComputed,
    configForCurrentTable,
    loadConfigForTable,
  };
}

export function deleteConfigForCurrentTable({ id }) {
  if (configForAllTable.value?.[id]) {
    delete configForAllTable.value[id];
  }
}
